import styled from "styled-components";
import { OpenInNewIcon, palette } from "@dev/ee-components";

export const OpenInNewIconBlue = styled(OpenInNewIcon as any)<{$isDisabled: boolean}>`
    fill: ${({$isDisabled}) => $isDisabled ? palette.gray[4] : palette.indigo[6]};
`;
